import React from 'react';
import { Box, Heading, Text, useThemedValueSwitch } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export interface TitleDescriptionProps {
  title: string;
  description: string;
}

export const TitleDescription: React.FC<TitleDescriptionProps> = ({ title, description }) => {
  const { tvs } = useThemedValueSwitch();
  return (
    <Box>
      <Heading
        as='h3'
        size='sm'
        borderBottom={tvs({ tq: 'none' }, `1px solid ${COLOURS.gray[300]}`)}
        py={tvs({ tq: 0 }, 2)}
        px={tvs({ tq: { base: 0 } }, { base: 0, md: 2 })}
        mb='0.25rem'
        d='inline-block'
      >
        {title}
      </Heading>
      <Text py={tvs({ tq: 0 }, 2)} px={tvs({ tq: { base: 0 } }, { base: 0, md: 2 })}>
        {description}
      </Text>
    </Box>
  );
};
